import React, { useState, useRef } from "react";
import { IonApp, IonContent, IonHeader, IonIcon, IonItem, IonList, IonMenu, IonMenuToggle, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import topics from "../../../menus/ClassOne/Gerunds";

const GerundsExercise: React.FC = () => {

    return (
        <div className={`my-topic-container`}> 
            {topics.map((slide, index) => (
                <div key={index} className="my-topic">
                    <a href={`${slide.url}`} style={{textDecoration:'none', color: 'inherit'}}>
                        <div className="class-card"
                        >
                            <h4 className="card-content">{slide.title}</h4>
                        </div>
                    </a>
                </div>
            ))}
        </div>
    );
};
export default GerundsExercise;